import { dataMiniAppWechat } from 'dls-icons-data'
import { createIcon } from '../common'

const IconMiniAppWechat = /*#__PURE__*/createIcon(dataMiniAppWechat)
export default IconMiniAppWechat
